import { Component } from '@angular/core';
import { NavigationComponent } from '@spartacus/storefront';

@Component({
  selector: 'cx-navigation',
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
  standalone: false,
})
export class CustomNavigationComponent extends NavigationComponent {}
